import { render } from "./CallToAction.vue?vue&type=template&id=034a614a&scoped=true&ts=true"
import script from "./CallToAction.vue?vue&type=script&lang=ts"
export * from "./CallToAction.vue?vue&type=script&lang=ts"

import "./CallToAction.vue?vue&type=style&index=0&id=034a614a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034a614a"]])

export default __exports__